// employeeAPI.js
import apiClient, { apiSendFileHeader, constr_uri } from '../../../../../../services/apiClient';
import { toast } from 'react-toastify';

// Допоміжна для завантаження файлів
function readFileAsBuffer(file) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload  = function() { resolve(reader.result); };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
    });
}

export const employeeAPI = {

    // ── Список співробітників ─────────────────────────────────────

    async getActiveEmployees(kindergartenId) {
        try {
            const response = await apiClient.get(`employees/${kindergartenId}/active`);
            const list = response.data || [];
            return list.map(emp => ({ ...emp, id: emp._id || emp.id }));
        } catch (error) {
            console.error('getActiveEmployees:', error);
            throw error;
        }
    },

    async getDismissedEmployees(kindergartenId) {
        try {
            const response = await apiClient.get(`employees/${kindergartenId}/dismissed`);
            const list = response.data || [];
            return list.map(emp => ({ ...emp, id: emp._id || emp.id }));
        } catch (error) {
            console.error('getDismissedEmployees:', error);
            throw error;
        }
    },

    // ── Картка співробітника ──────────────────────────────────────

    async getEmployeeById(kindergartenId, employeeId) {
        try {
            const response = await apiClient.get(`employees/${kindergartenId}/employee/${employeeId}`);
            return response.data;
        } catch (error) {
            console.error('getEmployeeById:', error);
            throw error;
        }
    },

    async createEmployee(kindergartenId, employeeData) {
        try {
            const response = await apiClient.post(`employees/${kindergartenId}`, employeeData);
            return response.data;
        } catch (error) {
            console.error('createEmployee:', error);
            throw error;
        }
    },

    async updateEmployee(kindergartenId, employeeId, employeeData) {
        try {
            const response = await apiClient.put(`employees/${kindergartenId}/${employeeId}`, employeeData);
            return response.data;
        } catch (error) {
            console.error('updateEmployee:', error);
            throw error;
        }
    },

    async dismissEmployee(kindergartenId, employeeId) {
        try {
            const response = await apiClient.patch(`employees/${kindergartenId}/${employeeId}/dismiss`);
            return response.data;
        } catch (error) {
            console.error('dismissEmployee:', error);
            throw error;
        }
    },

    async restoreEmployee(kindergartenId, employeeId) {
        try {
            const response = await apiClient.patch(`employees/${kindergartenId}/${employeeId}/restore`);
            return response.data;
        } catch (error) {
            console.error('restoreEmployee:', error);
            throw error;
        }
    },

    // ── Посади ───────────────────────────────────────────────────

    async getAvailableStaffPositions(kindergartenId) {
        try {
            const response = await apiClient.get(`employees/${kindergartenId}/available-positions`);
            return response.data || [];
        } catch (error) {
            console.error('getAvailableStaffPositions:', error);
            throw error;
        }
    },

    async checkPositionAvailability(kindergartenId, { staffPositionId, requiredUnits, employeeId }) {
        try {
            const response = await apiClient.post(`employees/${kindergartenId}/check-availability`, {
                staffPositionId,
                requiredUnits,
                employeeId
            });
            return response.data;
        } catch (error) {
            console.error('checkPositionAvailability:', error);
            throw error;
        }
    },

    // ── Фото співробітника ────────────────────────────────────────

    async uploadPhoto(kindergartenId, employeeId, file) {
        const fileInfo = {
            employee_id: employeeId,
            kg_id:       kindergartenId,
            name:        file.name,
            mtype:       file.type,
            length:      file.size,
            date:        new Date().toISOString(),
        };
        const buffer = await readFileAsBuffer(file);
        const response = await apiSendFileHeader(
            `employees/${kindergartenId}/${employeeId}/photo`,
            buffer,
            fileInfo
        );
        if (!response.ok) throw new Error('Upload failed: ' + response.status);
        const json = await response.json();
        // responseHandler.data обгортає в { data: { fileId, docId } }
        return json.data || json;
    },

    async deletePhoto(kindergartenId, employeeId, fileId) {
        const response = await apiClient.delete(
            `employees/${kindergartenId}/${employeeId}/photo/${fileId}`
        );
        return response.data;
    },

    async getPhotos(kindergartenId, employeeId) {
        const response = await apiClient.get(
            `employees/${kindergartenId}/${employeeId}/photos`
        );
        return response.data || { photos: [], docId: null, avatarFileId: null };
    },

    async setAvatar(kindergartenId, employeeId, fileId) {
        const response = await apiClient.put(
            `employees/${kindergartenId}/${employeeId}/avatar`,
            { fileId }
        );
        return response.data;
    },

    // ── Публічний профіль ─────────────────────────────────────────

    async updatePublicProfile(kindergartenId, employeeId, profileData) {
        const response = await apiClient.put(
            `employees/${kindergartenId}/${employeeId}/public-profile`,
            profileData
        );
        return response.data;
    },

    async getPublicTeam(kindergartenId) {
        const response = await apiClient.get(
            `public/employees/${kindergartenId}/team`
        );
        return response.data || [];
    },

    async updateDisplayOrder(kindergartenId, orderedIds) {
        const response = await apiClient.put(
            `employees/${kindergartenId}/display-order`,
            { order: orderedIds }
        );
        return response.data;
    },
};